import { RESET_ONBEHALF } from './';

export default payload => ({
  type: RESET_ONBEHALF,
  payload,
});
